"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalSessionRepository = void 0;
class PortalSessionRepository {
    constructor(client) {
        this.clientWithRetry = client.clientWithRetry;
        this.clientWithoutRetry = client.clientWithoutRetry;
    }
    createByChargebeeId(chargebeeId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            // Creating portal session has no effect on billing
            // So the creation can be called multiple times without issue
            const { data } = yield this.clientWithRetry.post(`/portal_sessions/${chargebeeId}`, undefined, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return data;
        });
    }
}
exports.PortalSessionRepository = PortalSessionRepository;
//# sourceMappingURL=PortalSessionRepository.js.map